import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  rootBorder: {
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
    marginLeft: 10,
    marginRight: 10,
  },
  rootBorderTablet: {
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
    marginLeft: 20,
    marginRight: 20,
  },
});
